import { COMPANY_FLOW_TYPE, PRL_FLOW_TYPE, PRODUCT_FLOW_TYPE } from "constants/flowTypes";
import { useParams } from "react-router-dom";
import useQueryPrl from "api/queries/useQueryPrl";
import useQueryProduct from "api/queries/useQueryProduct";
import useQueryCompany from "api/queries/useQueryCompany";

const useGetData = () => {
  const { id = "123", type: flowType } = useParams();
  const {
    data: prlData,
    isLoading: isLoadingPrl,
    error: isErrorPrl
  } = useQueryPrl(id, {
    enabled: flowType === PRL_FLOW_TYPE
  });

  const {
    data: productData,
    isLoading: isLoadingProduct,
    error: isErrorProduct
  } = useQueryProduct(id, { enabled: flowType === PRODUCT_FLOW_TYPE });

  const {
    data: companyData,
    isLoading: isLoadingCompany,
    error: isErrorCompany
  } = useQueryCompany(id, { enabled: flowType === COMPANY_FLOW_TYPE });

  const getDataFlowType = () => {
    if (flowType === PRL_FLOW_TYPE) {
      return prlData;
    } else if (flowType === PRODUCT_FLOW_TYPE) {
      return productData;
    } else if (flowType === COMPANY_FLOW_TYPE) {
      return companyData;
    }
  };

  const data = getDataFlowType();
  const isLoading =
    (flowType === PRL_FLOW_TYPE && isLoadingPrl) ||
    (flowType === PRODUCT_FLOW_TYPE && isLoadingProduct) ||
    (flowType === COMPANY_FLOW_TYPE && isLoadingCompany);
  const isError =
    (flowType === PRL_FLOW_TYPE && isErrorPrl) ||
    (flowType === PRL_FLOW_TYPE && isErrorProduct) ||
    (flowType === COMPANY_FLOW_TYPE && isErrorCompany);
  return { data, isLoading, isError, prlData, productData, companyData };
};

export default useGetData;
